import SimpleGrid from '~/common/components/Grids/Grid/SimpleGrid';
import Text from '~/common/components/Texts/Text';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import BreakdownContainer from '../BreakdownContainer';
import AnnualBreakdown from './AnnualBreakdown';
import MonthlyIncome from './MonthlyIncome';
import TrendingAnalysis from './TrendingAnalysis';

type Form1120CalculationBreakdownProps = {
  selectedResult: CalculationResult;
  onNewWindow?: () => void;
  hideAccordion?: boolean;
};

const Form1120CalculationBreakdown = ({
  selectedResult,
  onNewWindow,
  hideAccordion = false,
}: Readonly<Form1120CalculationBreakdownProps>) => {
  const years = selectedResult
    .getFiscalYears()
    .filter((year) => year !== 0)
    .sort((a, b) => b - a);

  const formula = selectedResult.formulas[0];
  const formulaId = formula?.formulaId ?? 0;

  return (
    <BreakdownContainer
      header="1120 Calculation Breakdown"
      onNewWindow={onNewWindow}
      hideAccordion={hideAccordion}
    >
      {formula && (
        <Text pb={4} fontSize="sm">
          <Text as="span" fontWeight="bold">
            Monthly Income Equation:&nbsp;
          </Text>
          {formula.formula}
        </Text>
      )}
      <SimpleGrid
        w={`${50 * Math.min(years.length, 2)}%`}
        columns={Math.min(2, years.length)}
        spacingX={8}
        spacingY={8}
        pb={4}
      >
        {years.map((currentYear) => (
          <AnnualBreakdown
            selectedResult={selectedResult}
            currentYear={currentYear}
            formulaId={formulaId}
            key={currentYear}
          />
        ))}
      </SimpleGrid>
      <MonthlyIncome
        selectedResult={selectedResult}
        currentYear={years[0]}
        formulaId={formulaId}
      />
      {years.length > 1 && <TrendingAnalysis selectedResult={selectedResult} />}
    </BreakdownContainer>
  );
};

export default Form1120CalculationBreakdown;
